export default "__VITE_ASSET__DVsGI3PL__"